import axios from 'axios';
import { PhasedConstructionModel } from 'app/edozvola/cases/phased-construction/model/phased-construction.model';

export const fetchPhasedConstruction = async (idCase: string): Promise<PhasedConstructionModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/phased-construction/${idCase}`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const savePhasedConstruction = async (idCase: string, phasedConstruction: PhasedConstructionModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/phased-construction/${idCase}`, phasedConstruction)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};
